const ButtonInput = ({onClick, content, loading = false, loadingContent = "Cargando...", color = 'gray', disabled = false}) => {
  
  // Mapeo de colores para evitar interpolación dinámica en Tailwind
  const colorClasses = {
    gray: {
      normal: 'bg-gray-200 hover:bg-gray-300 text-gray-800',
      loading: 'bg-gray-300 text-gray-600',
    },
    green: {
      normal: 'bg-emerald-600 hover:bg-emerald-700 text-white',
      loading: 'bg-gray-300 text-gray-600',
    },
    red: {
      normal: 'bg-red-600 hover:bg-red-700 text-white',
      loading: 'bg-gray-300 text-gray-600',
    },
    blue: {
      normal: 'bg-blue-600 hover:bg-blue-700 text-white',
      loading: 'bg-gray-300 text-gray-600',
    },
  };

  const isDisabled = loading || disabled;
  const buttonClasses = isDisabled 
    ? colorClasses[color]?.loading || colorClasses.gray.loading
    : colorClasses[color]?.normal || colorClasses.gray.normal;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={`px-3 py-1 rounded text-xs ${buttonClasses}`}
    >
      {loading ? loadingContent : content}
    </button>
  )
}

export default ButtonInput;